import Period from 'enums/period';
import { MatchEventType, matchStatusEvents } from '../enums/matchEventType';
import { MatchStatus } from '../enums/matchStatus';

export default function (
  matchEventTypeId: MatchEventType,
  matchStatusId: MatchStatus,
  penaltiesShootoutStarted?: boolean,
): Period {
  if (matchStatusEvents.includes(matchEventTypeId)) {
    return handleMatchStatusEvents(matchStatusId, penaltiesShootoutStarted) as Period;
  }

  switch (matchStatusId) {
    case MatchStatus.NOT_STARTED:
      return Period.BEFORE_MATCH;

    case MatchStatus.FIRST_HALF:
      return Period.FIRST_HALF;

    case MatchStatus.HALF_TIME:
      return Period.HALF_TIME;

    case MatchStatus.SECOND_HALF:
      return Period.SECOND_HALF;

    case MatchStatus.PAUSE_BEFORE_EXTRA_TIME:
      return Period.PAUSE_BEFORE_EXTRA_TIME;

    case MatchStatus.FIRST_HALF_EXTRA_TIME:
      return Period.FIRST_HALF_EXTRA_TIME;

    case MatchStatus.HALF_TIME_EXTRA_TIME:
      return Period.HALF_TIME_EXTRA_TIME;

    case MatchStatus.SECOND_HALF_EXTRA_TIME:
      return Period.SECOND_HALF_EXTRA_TIME;

    case MatchStatus.PENALTIES:
      if (penaltiesShootoutStarted) {
        return Period.PENALTIES_SHOOTOUT;
      }
      return Period.PAUSE_BEFORE_PENALTIES_SHOOTOUT;

    case MatchStatus.PLAYED:
      return Period.AFTER_MATCH;
  }

  return Period.BEFORE_MATCH;

  function handleMatchStatusEvents(matchStatusId: number, penaltiesShootoutStarted?: boolean): number {
    switch (matchEventTypeId) {
      case MatchEventType.HALF_TIME:
        return Period.FIRST_HALF;
      case MatchEventType.SECOND_HALF:
        return Period.HALF_TIME;

      case MatchEventType.MATCH_ENDS:
        if (penaltiesShootoutStarted) {
          return Period.PENALTIES_SHOOTOUT;
        } else if ([MatchStatus.SECOND_HALF_EXTRA_TIME].includes(matchStatusId)) {
          return Period.SECOND_HALF_EXTRA_TIME;
        }
        return Period.SECOND_HALF;

      case MatchEventType.FIRST_HALF_EXTRA_TIME:
        return Period.FIRST_HALF_EXTRA_TIME;

      case MatchEventType.HALF_TIME_EXTRA_TIME:
        return Period.HALF_TIME_EXTRA_TIME;

      case MatchEventType.SECOND_HALF_EXTRA_TIME:
        return Period.SECOND_HALF_EXTRA_TIME;

      case MatchEventType.MATCH_KICKS_OFF:
      default:
        return Period.BEFORE_MATCH;
    }
  }
}
